<template>
  <div class="generic-dropdown" v-show="elementActive">
    <div class="col-3 field-label">{{label}}</div>
    <div class="col-7 field-response">
        <select v-model="currentValue" class="form-select inner-select" :disabled="elementDisabled">
          <option :value="null" v-show="currentValueDefined">Please Select</option>
          <option :value="undefined" v-show="!currentValueDefined">Please Select</option>
          <option v-for="val in values" :value="val.value" :key="val.id">{{val.display}}</option>
        </select>
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'
import ProgramSpecificMixin from './ProgramSpecificMixin'

export default {
  name: 'GenericDropDown',
  mixins: [PropsMixin, ComputedMixin, ProgramSpecificMixin],
  data () {
    return {
    }
  },
  computed: {
    values () {
      return this.formField.formListItems
    }
  },
  mounted () {
  },
  watch: {
  }
}
</script>
